module.exports = __webpack_public_path__ + "static/media/9DESA13.f5e0fe5e.jpg";